(function () {
  'use strict';

  /* =========================
     Configuration
  ========================== */
  const WEBHOOK_URL =
    'https://automation.ethicalhq.com/webhook/4eaf8f5f-0390-42df-b8b3-7f9ccfaea0c1';

  const EMAILABLE_API_KEY = 'live_77cf6e9b8b568e336d63';

  /* =========================
     Init
  ========================== */
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('cn-generic-subscribe-form');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      event.stopPropagation();
      handleSubscribeForm(form);
    });
  });

  /* =========================
     Core handler
  ========================== */
  async function handleSubscribeForm(form) {
    const emailInput = document.getElementById('cn-sub-email');
    const submitBtn = document.getElementById('cn-btn-subscribe');

    if (!emailInput || !submitBtn) return;

    const email = emailInput.value.trim();

    if (!email) {
      alert('Please enter your email address');
      return;
    }

    if (!isValidEmailFormat(email)) {
      alert('Please enter a valid email address');
      return;
    }

    const originalValue = submitBtn.value;
    const waitText = submitBtn.getAttribute('data-wait') || 'Sending…';

    submitBtn.value = waitText;
    submitBtn.disabled = true;

    try {
      /* =========================
         Emailable validation
      ========================== */
      const isValid = await validateWithEmailable(email);
      if (!isValid) {
        throw new Error('Please check your email address and try again.');
      }

      /* =========================
         Webhook submission
      ========================== */
      await sendToWebhook({
        email,
        'form-name': 'Article Subscription',
        context: {
          ...(getHubspotUTK() && { hutk: getHubspotUTK() }),
          pageUri: window.location.href,
          pageName: document.title
        }
      });

      /* =========================
         Success UI
      ========================== */
      const wrapper = form.closest('.w-form');
      if (wrapper) {
        const successDiv = wrapper.querySelector('.w-form-done');
        const errorDiv = wrapper.querySelector('.w-form-fail');

        if (successDiv) successDiv.style.display = 'block';
        if (errorDiv) errorDiv.style.display = 'none';

        form.style.display = 'none';
      }

    } catch (err) {
      console.error('Subscribe error:', err);

      const wrapper = form.closest('.w-form');
      if (wrapper) {
        const errorDiv = wrapper.querySelector('.w-form-fail');
        if (errorDiv) errorDiv.style.display = 'block';
      }

      alert(err.message || 'Something went wrong. Please try again.');

      submitBtn.value = originalValue;
      submitBtn.disabled = false;
    }
  }

  /* =========================
     Webhook
  ========================== */
  async function sendToWebhook(payload) {
    const res = await fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) throw new Error('Webhook request failed');
  }

  /* =========================
     Emailable
  ========================== */
  async function validateWithEmailable(email) {
    try {
      const res = await fetch(
        `https://api.emailable.com/v1/verify?email=${encodeURIComponent(email)}&api_key=${EMAILABLE_API_KEY}`
      );

      if (!res.ok) return true;

      const data = await res.json();

      if (
        data.state === 'undeliverable' &&
        (data.reason === 'invalid_domain' || data.reason === 'no_mx_record')
      ) {
        return false;
      }

      return true;
    } catch {
      return true;
    }
  }

  /* =========================
     HubSpot UTK
  ========================== */
  function getHubspotUTK() {
    const m = document.cookie.match(/hubspotutk=([^;]+)/);
    return m ? m[1] : '';
  }

  /* =========================
     Helpers
  ========================== */
  function isValidEmailFormat(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  /* =========================
     Highlight CTA
  ========================== */
  function initHighlightCTA() {
    const formEl = document.querySelector('.cn-generic-subscribe');
    const overlay = document.querySelector('.cn-generic-subscribe-overlay');
    const closeBtn = document.querySelector('.cn-generic-subscribe-close');

    if (!formEl || !overlay || !closeBtn) return;

    var hasHighlighted = false;
    var observer;

    function fadeIn(el) {
      el.style.display = 'block';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          el.classList.add('visible');
        });
      });
    }

    function fadeOut(el) {
      el.classList.remove('visible');
      el.addEventListener('transitionend', function handler() {
        el.style.display = 'none';
        el.removeEventListener('transitionend', handler);
      });
    }

    function closeOverlay() {
      observer.disconnect();
      fadeOut(overlay);
      closeBtn.style.display = 'none';
      formEl.classList.remove('highlight');
    }

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !hasHighlighted) {
          formEl.classList.add('highlight');
          fadeIn(overlay);
          closeBtn.style.display = 'flex';
          hasHighlighted = true;
        } else if (!entry.isIntersecting && hasHighlighted) {
          formEl.classList.remove('highlight');
          fadeOut(overlay);
          closeBtn.style.display = 'none';
          observer.disconnect();
        }
      });
    }, { root: null, rootMargin: '0px', threshold: 0.5 });

    observer.observe(formEl);

    closeBtn.addEventListener('click', closeOverlay);

    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeOverlay();
    });
  }

  document.addEventListener('DOMContentLoaded', initHighlightCTA);

})();
